import {
  DRIFT_CHAT_PLAYBOOK_EVENTS_DIMENSIONS,
  PLAYBOOKS_CHAT_DIMENSIONS,
} from 'cube/constants'

import type { CubeQuery } from '@driftt/dds.reports'

export const PlaybookFastlaneOverviewQuery: CubeQuery = {
  name: 'PlaybookFastlaneOverviewMetrics',
  queryName: 'PlaybookFastlaneOverviewMetrics',
  query: {
    measures: [
      DRIFT_CHAT_PLAYBOOK_EVENTS_DIMENSIONS.COUNT_FORMFILLS,
      DRIFT_CHAT_PLAYBOOK_EVENTS_DIMENSIONS.COUNT_SENT,
      DRIFT_CHAT_PLAYBOOK_EVENTS_DIMENSIONS.COUNT_END_USER_ENGAGED,
      DRIFT_CHAT_PLAYBOOK_EVENTS_DIMENSIONS.COUNT_CONVERSATION_HELD,
      DRIFT_CHAT_PLAYBOOK_EVENTS_DIMENSIONS.COUNT_MEETING_BOOKED,
      DRIFT_CHAT_PLAYBOOK_EVENTS_DIMENSIONS.MAX_EVENTS,
    ],
    dimensions: [
      PLAYBOOKS_CHAT_DIMENSIONS.PLAYBOOK_ID,
      PLAYBOOKS_CHAT_DIMENSIONS.PLAYBOOK_NAME,
      PLAYBOOKS_CHAT_DIMENSIONS.PLAYBOOK_STATUS,
      PLAYBOOKS_CHAT_DIMENSIONS.PLAYBOOK_REPORT_TYPE,
      PLAYBOOKS_CHAT_DIMENSIONS.PLAYBOOK_IS_AI_ENABLED,
    ],
  },
}
